import { useAllContacts } from 'src/ui/features/contacts/hooks/all-contacts.hook';
import { Loader } from '../../../loader/Loader';
import { HookControlProps } from '../../HookForm';
import { useContactSelectOptions } from './ContactSelectControl';
import { MultiSelectControl } from './MultiSelectControl';

export const ContactMultiSelectControl = (
    props: HookControlProps
): React.ReactElement<any, any> | null => {
    const { fetch, contacts } = useAllContacts();
    const options = useContactSelectOptions(contacts);

    return (
        <Loader state={fetch} useCard={true}>
            <MultiSelectControl {...props} options={options} />
        </Loader>
    );
};
